import React from 'react';
import LawyerMembership from '../components/LawyerMembership';

const LawyerPage = () => {
  return (
    <div className="lawyer-page">
      <LawyerMembership />
    </div>
  );
};

export default LawyerPage;
